<ng-container *ngIf="isLoading; else pageContent">
  <div class="auth-spinner">
    <mat-spinner [diameter]="40"></mat-spinner>
  </div>
</ng-container>

<ng-template #pageContent>
  <div class="auth-wrap">
    <div class="auth-left">
      <div>
        <a routerLink="/" class="auth-logo-row">
          <img
            src="assets/images/BeExpert-logo (3).svg"
            alt="BeExpert"
            class="auth-logo-img"
          />
        </a>

        <div class="auth-step-pill">Step 2 of 2 — Verify your login</div>

        <h1 class="auth-left-h1">You're almost in.<br>Just one more<br>quick step.</h1>
        <p class="auth-left-sub">
          We've sent a 6-digit OTP to your registered email address. Enter it below to access your account.
        </p>

        <div class="auth-trust-item">
          <span class="auth-check-icon">✓</span>
          OTP sent via Email to your address
        </div>
        <div class="auth-trust-item">
          <span class="auth-check-icon">✓</span>
          Valid for 2 minutes
        </div>
        <div class="auth-trust-item">
          <span class="auth-check-icon">✓</span>
          Your email is never shared with anyone
        </div>

        <div class="auth-ill-cards">
          <div class="auth-ill-card">
            <div class="auth-ill-icon text-white">
              <i class="bi bi-envelope-paper"></i>
            </div>
            <div>
              <span class="auth-ill-title">Email Sent</span>
              <span class="auth-ill-sub">Your OTP: ● ● ● ● ● ●  · Just now</span>
            </div>
          </div>
          <div class="auth-ill-card">
            <div class="auth-ill-icon text-white">
              <i class="bi bi-graph-up-arrow"></i>
            </div>
            <div>
              <span class="auth-ill-title">Resume your journey</span>
              <span class="auth-ill-sub">Your roadmap &amp; progress are waiting</span>
            </div>
          </div>
        </div>
      </div>

      <div class="auth-stats-bar">
        <div class="auth-stat-col">
          <span class="auth-stat-num">10K+</span>
          <span class="auth-stat-lbl">Active students</span>
        </div>
        <div class="auth-stat-col">
          <span class="auth-stat-num">Free</span>
          <span class="auth-stat-lbl">To get started</span>
        </div>
        <div class="auth-stat-col">
          <span class="auth-stat-num">5 min</span>
          <span class="auth-stat-lbl">To your score</span>
        </div>
      </div>
    </div>

    <div class="auth-right">
      <a routerLink="/" class="auth-mobile-bar">
        <img src="assets/images/beExpert.svg" alt="BeExpert" />
        <span class="mt-1 beexpert">BeExpert</span>
      </a>
      <div class="auth-form-box">
        <div class="auth-form-title">Verify your Email</div>
        <div class="auth-form-sub">
          We have sent 6-digit code to {{ userEmail }}
        </div>

        <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
          <div class="auth-field">
            <label class="auth-label">Enter OTP</label>
            <div class="auth-phone-wrap">
              <input
                type="text"
                formControlName="otp"
                class="auth-phone-input"
                id="otp"
                placeholder="enter otp"
                maxlength="6"
                inputmode="numeric"
              />
            </div>

            <div
              class="col-md-10 offset-md-1 mb-2 ms-3"
              *ngIf="
                loginForm.controls['otp'].touched &&
                loginForm.controls['otp'].invalid
              "
            >
              <small
                class="text-danger smaller-text"
                *ngIf="loginForm.controls['otp'].errors?.['required']"
              >
                OTP is required</small
              >

              <small
                class="text-danger smaller-text"
                *ngIf="loginForm.controls['otp'].errors?.['pattern']"
              >
                Please enter a valid 6-digit numeric OTP
              </small>
            </div>
          </div>

          <button
            type="submit"
            class="auth-submit"
            [disabled]="loginForm.invalid"
          >
            Verify
          </button>
        </form>

        <div class="text-center mt-4 login-font">
          <ng-container *ngIf="!canResendOtp; else resendBlock"
            >Didn't receive the code?
            <span class="text-muted">Resend OTP in {{ displayTime }}</span>
          </ng-container>
          <ng-template #resendBlock>
            <span style="cursor: pointer"
              >Didn't receive the code?
              <span class="text-primary" (click)="resendOtp()">Resend OTP</span>
            </span>
          </ng-template>
        </div>

        <div class="auth-divider">
          <span>or</span>
        </div>

        <button class="auth-submit mb-3" routerLink="/login-password" [queryParams]="{redirectUrl : redirectUrl }">
          Login with Password
        </button>

        <div class="auth-footer-link">
          Don't have an account? <a (click)="goToLoginPage()">Change Email</a>
        </div>
      </div>
    </div>
  </div>
</ng-template>